export default __webpack_public_path__ + "static/ravi_story-7afc46dc8d2664f941eb9c4bfc5d1f4c.png";